"use client";

import { Button } from "@mui/material";
import type { SnackbarAction } from "notistack";
import {
  SnackbarProvider as NotistackSnackbarProvider,
  useSnackbar,
} from "notistack";
import { useTranslations } from "next-intl";

const Action: SnackbarAction = (key) => {
  const snackBar = useSnackbar();
  const t = useTranslations("common");
  return (
    <Button
      variant="text"
      sx={{ color: "white" }}
      onClick={() => {
        snackBar.closeSnackbar(key);
      }}
    >
      {t("dismiss")}
    </Button>
  );
};

export const SnackbarProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <NotistackSnackbarProvider
      action={Action}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      autoHideDuration={3000}
      maxSnack={3}
      preventDuplicate
    >
      {children}
    </NotistackSnackbarProvider>
  );
};
